import { useEffect } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash.isempty';

import { LoadingAnimation } from 'app/shared/components/LoadingAnimation/LoadingAnimation';
import { HtmlHeader } from 'app/shared/components/HtmlHeader/HtmlHeader';
import { BASE_URL, CONTENTFUL_HEYCAR } from 'app/config';
import { ErrorPage } from 'app/shared/components/ErrorPage/ErrorPage';
import { ContentfulEntry } from 'app/marketplace/contentful/ContentfulEntry/ContentfulEntry';
import { LoadingPageWrapperSt } from 'app/marketplace/contentful/spaces/magazine/entries/SharedComponentsSt/SharedComponentsSt.css';
import { locationShape } from 'app/shared/utils/propTypes';

import { InsuranceHubHeader } from './sections/InsuranceHubHeader/InsuranceHubHeader';
import * as Styled from './InsuranceHub.css';
import { SectionBenefits } from './sections/benefits';

export const Contentful = (props) => {
  useEffect(() => {
    const { entry, getPage, location } = props;

    if (_isEmpty(entry)) {
      getPage(location.pathname, CONTENTFUL_HEYCAR);
    }
  }, []);

  const { entry, contentfulLoading, locale, location } = props;

  const localizedProps = entry && entry.fields;
  const htmlHeaderTitle = localizedProps ? localizedProps.title : 'heycar';
  const htmlHeaderDescription = localizedProps
    ? localizedProps.description
    : '';
  const htmlHeaderUrl = `${BASE_URL}${location.pathname}`;
  const currentUrl = `${BASE_URL}${location.pathname}${location.search}`;

  if (entry && entry.error) {
    return (
      <ErrorPage
        errorCode={404}
        errorId="marketplace.contentful.ContentfulEntry.notFound"
      />
    );
  }

  return (
    <div>
      <HtmlHeader
        url={htmlHeaderUrl}
        title={htmlHeaderTitle}
        description={htmlHeaderDescription}
        currentUrl={currentUrl}
        index="index,follow"
      />

      {contentfulLoading ? (
        <LoadingPageWrapperSt>
          <LoadingAnimation isLoading />
        </LoadingPageWrapperSt>
      ) : (
        <>
          <Styled.InsuranceHubWrapperSt>
            <InsuranceHubHeader />
            <SectionBenefits />
            <ContentfulEntry entry={entry} locale={locale} />
          </Styled.InsuranceHubWrapperSt>
        </>
      )}
    </div>
  );
};

Contentful.propTypes = {
  entry: PropTypes.object,
  contentfulLoading: PropTypes.bool,
  getPage: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  location: locationShape.isRequired,
};

Contentful.defaultProps = {
  entry: null,
  contentfulLoading: true,
};
